import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SFFormBuilder } from "@sf-core";

import getSchema from "./schema.js";
import uischema from "./uischema.json";

const UserForm = ({ onChange, data }) => {
  const [schema, setSchema] = useState(null);

  useEffect(async () => {
    setSchema(await getSchema());
  }, []);

  if (!schema) return null;

  return (
    <SFFormBuilder
      schema={schema}
      uischema={uischema}
      data={data}
      onChange={onChange}
    />
  );
};

UserForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default UserForm;
